import React from 'react';

import s from './upsellsNotification.scss';

export type PropsType = {
    icon?: React.ReactElement;
    notice?: string;
    children: React.ReactNode;
};

/**
 * UpsellsNotification component which display message and can display icon with notice
 * @param {PropsType} props - Component props
 * @return {React.ReactElement} component
 */
export const UpsellsNotification: React.FC<PropsType> = React.memo(({children, icon, notice}) => (
    <div className={s.notification}>
        <div className={s.content}>{children}</div>
        {icon && (
            <div className={s.rightSide}>
                {icon}
                {notice && <span className={s.notice}>{notice}</span>}
            </div>
        )}
    </div>
));

UpsellsNotification.displayName = 'UpsellsNotification';
